import script from "./StorageTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./StorageTab.vue?vue&type=script&setup=true&lang=ts"

import "./StorageTab.vue?vue&type=style&index=0&id=5e3be659&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3be659"]])

export default __exports__